import React from 'react';

import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import FormControl from '@material-ui/core/FormControl';
import Button from '@material-ui/core/Button';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import Checkbox from '@material-ui/core/Checkbox';

import * as classes from './AssignTabSidePanel.module.css';

const AssignTabSidePanel = ({
    ...props
}) => {
    const ruleName = { name: 'Nathans Test Rule' };

    const MenuProps = {
        disablePortal:      true,
        getContentAnchorEl: () => null,
        PaperProps:         {
            style: {
                maxHeight: 500
            },
        },
    };

    return (
        <div className={classes.SidePanel}>
            <div className={classes.RuleContainer}>
                <div className={classes.RuleTitle}>
                    Rule Name
                </div>
                <div className={classes.Rule}>
                    {ruleName.name}
                </div>
            </div>
            <div>
                <div style={{ paddingTop: '1.5rem' }}>
                    <span className={classes.MenuTitle}>
                        Universe
                    </span>
                    <div className={classes.SubListContainer}>
                        <FormControl
                            variant="outlined"
                            size="small"
                            className={classes.InputWrapper}
                        >
                            <InputLabel
                                htmlFor="templateName"
                                classes={{
                                    error:   classes.error,
                                    focused: classes.labelFocused,
                                    root:    classes.label
                                }}
                            >
                                Equipment/System Type
                            </InputLabel>
                            <Select
                                value={0}
                                id="type"
                                MenuProps={MenuProps}
                                name="type"
                                classes={{
                                    root: classes.input
                                }}
                            >
                                <MenuItem
                                    key={0}
                                    value={0}
                                >
                                    Analog
                                </MenuItem>
                            </Select>
                        </FormControl>
                        <FormControl
                            variant="outlined"
                            size="small"
                            className={classes.InputWrapper}
                        >
                            <InputLabel
                                htmlFor="templateName"
                                classes={{
                                    error:   classes.error,
                                    focused: classes.labelFocused,
                                    root:    classes.label
                                }}
                            >
                                Template
                            </InputLabel>
                            <Select
                                value={0}
                                id="type"
                                MenuProps={MenuProps}
                                name="type"
                                classes={{
                                    root: classes.input
                                }}
                            >
                                <MenuItem
                                    key={0}
                                    value={0}
                                >
                                    Analog
                                </MenuItem>
                            </Select>
                        </FormControl>
                        <FormControl
                            variant="outlined"
                            size="small"
                            className={classes.InputWrapper}
                        >
                            <InputLabel
                                htmlFor="templateName"
                                classes={{
                                    error:   classes.error,
                                    focused: classes.labelFocused,
                                    root:    classes.label
                                }}
                            >
                                Client
                            </InputLabel>
                            <Select
                                value={0}
                                id="type"
                                MenuProps={MenuProps}
                                name="type"
                                classes={{
                                    root: classes.input
                                }}
                            >
                                <MenuItem
                                    key={0}
                                    value={0}
                                >
                                    Analog
                                </MenuItem>
                            </Select>
                        </FormControl>
                        <FormControl
                            variant="outlined"
                            size="small"
                            className={classes.InputWrapper}
                        >
                            <InputLabel
                                htmlFor="templateName"
                                classes={{
                                    error:   classes.error,
                                    focused: classes.labelFocused,
                                    root:    classes.label
                                }}
                            >
                                Site
                            </InputLabel>
                            <Select
                                value={0}
                                id="type"
                                MenuProps={MenuProps}
                                name="type"
                                classes={{
                                    root: classes.input
                                }}
                            >
                                <MenuItem
                                    key={0}
                                    value={0}
                                >
                                    Analog
                                </MenuItem>
                            </Select>
                        </FormControl>
                    </div>
                </div>
                <div style={{paddingTop: '1rem'}}>
                    <span className={classes.MenuTitle}>
                        Equipments
                    </span>
                    <div className={classes.SubListContainer}>
                        <List className={classes.FormulaList}>
                            <ListItem
                                key={0}
                                classes={{
                                    root: classes.FormulaListItem
                                }}
                            >
                                <Checkbox
                                    value="include"
                                    name="include"
                                    style={{
                                        transform: 'scale(1.5)',
                                        color:     'black'
                                    }}
                                />
                                <span className={classes.Text}>
                                    Select All
                                </span>
                            </ListItem>
                            <ListItem
                                key={1}
                                classes={{
                                    root: classes.FormulaListItem
                                }}
                            >
                                <Checkbox
                                    value="include"
                                    name="include"
                                    style={{
                                        transform: 'scale(1.5)',
                                        color:     'black'
                                    }}
                                />
                                <span className={classes.Text}>
                                    Equipment 1
                                </span>
                            </ListItem>
                            <ListItem
                                key={2}
                                classes={{
                                    root: classes.FormulaListItem
                                }}
                            >
                                <Checkbox
                                    value="include"
                                    name="include"
                                    style={{
                                        transform: 'scale(1.5)',
                                        color:     'black'
                                    }}
                                />
                                <span className={classes.Text}>
                                    Equipment 2
                                </span>
                            </ListItem>
                            <ListItem
                                key={3}
                                classes={{
                                    root: classes.FormulaListItem
                                }}
                            >
                                <Checkbox
                                    value="include"
                                    name="include"
                                    style={{
                                        transform: 'scale(1.5)',
                                        color:     'black'
                                    }}
                                />
                                <span className={classes.Text}>
                                    Equipment 3
                                </span>
                            </ListItem>
                        </List>
                    </div>
                </div>
                <div>
                    <Button
                        className={`${classes.Button}`}
                        data-test-id="confirm"
                        variant="contained"
                    >
                        Select Equipment
                    </Button>
                </div>
            </div>
        </div>
    );
};

export default AssignTabSidePanel;
